<template>
  <div>
    <notification
      v-for="notification in notifications"
      :key="notification.timestamp.getTime()"
      :timestamp="notification.timestamp"
      :type="notification.type"
      :icon="notification.icon"
      :message="notification.message"
      :timeout="notification.timeout"
      @on-close="removeNotification"
    >
    </notification>
  </div>
</template>
<script>
import Notification from './Notification.vue'
export default {
  components: {
    Notification,
  },
  data() {
    return {
      notifications: this.$notifications.state,
    }
  },
  methods: {
    removeNotification(timestamp) {
      this.$notifications.removeNotification(timestamp)
    },
  },
}
</script>
